/**
 * Tax configuration constants for Savor POS
 */

// Tax rates - Phase 2 (not used in Phase 1)
export const TAX_RATES = {
  COMPANY_INVOICE: 8, // 8% for company invoices
  HOUSEHOLD_INVOICE: 1.5, // 1.5% for household invoices
  DEFAULT: 8 // Default tax rate for Bánh kẹo Tết products
}

// Invoice source types - Phase 2 (not used in Phase 1)
export const INVOICE_SOURCE = {
  COMPANY: 'company',
  HOUSEHOLD: 'household'
}

export type TInvoiceSource = (typeof INVOICE_SOURCE)[keyof typeof INVOICE_SOURCE]

// Product categories that require tax - Currently not used directly
// (using isTaxableCategory function instead)
const TAXABLE_CATEGORIES = ['Bánh kẹo Tết', 'Phụ kiện BKT']

// Keywords to identify alcohol products - Phase 2
// (for household invoice restriction)
const ALCOHOL_KEYWORDS = [
  'rượu',
  'ruou',
  'wine',
  'cognac',
  'whisky',
  'vodka',
  'champagne',
  'alcohol',
  'liquor',
  'brandy',
  'rum',
  'gin',
  'beer',
  'bia'
]

/**
 * Check if a product category requires tax
 */
export function isTaxableCategory(category: string | undefined): boolean {
  if (!category) return false
  return TAXABLE_CATEGORIES.some(taxableCat =>
    category.toLowerCase().includes(taxableCat.toLowerCase())
  )
}

/**
 * Check if a text contains alcohol keywords - Phase 2
 * (for household invoice validation)
 */
export function containsAlcohol(text: string | undefined): boolean {
  if (!text) return false
  const lowerText = text.toLowerCase()
  return ALCOHOL_KEYWORDS.some(keyword => lowerText.includes(keyword))
}
